<template>
  <div class="no-data-box">
    <h2>Not available for this month</h2>
    <p>Please select a month after March 2019 from the top right of the page</p>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.no-data-box {
  height: 350px;
  margin-top: 15px;
  border: $border-base;
  border-radius: $border-radius;
  color: $gray-400;
  text-align: center;
  background: $white;

  h2 {
    padding-top: 175px;
    font-size: 25px;
  }
}
</style>
